import Bibliography from "./bibliography";
import Profile from "./profile";
import Projects from "./projects";
import { useMobileQuery } from "../hooks/mediahooks";
import MobileProjects from "./mobileprojects";
import { Navbar, Nav } from "react-bootstrap";

function MainPanel() {

	const isMobile = useMobileQuery();
	return (<>
		<div id="main">
			<Navbar>
				<Nav>
					<Nav.Link href="#profile">Profile</Nav.Link>
					<Nav.Link href="#projects">Projects</Nav.Link>
					<Nav.Link href="#bibliography">Publications</Nav.Link>
				</Nav>
			</Navbar>
			<Profile />
			{isMobile ?
				<MobileProjects />
				:
				<Projects />
			}
			<Bibliography />
		</div>
	</>)
}

export default MainPanel;